import { useTranslation } from "react-i18next";

import PageWrapper from "components/page/PageWrapper";
import MapKakao from "./MapKakao";

import bg from 'assets/images/banner/banner01.jpg';

export default function Location(){
  const {t} = useTranslation();
  const menuName= t('menu.sub-location');
  const path=[{url:'/corporation', name:t('menu.main-about')}, {url:'/corporation/location', name:menuName}];
  const title = t('location.banner.title')
  const comment = t('location.banner.comment')

  //const span = (chuck) => `<span class="font-semibold">${chuck}</span>`
  const address = t('location.body.address');
  const contact = t('location.body.contact');
  const email = t('location.body.email');

  return (
    <PageWrapper 
      bg={bg} 
      menuName={menuName}
      title={title}
      comment={comment}
      path={path}>
      <div className="flex justify-center">
        <div className={`flex flex-col items-center mb-20 lg:w-[700px]`}>
          <div className="mb-10">
            <p className="text-4xl">{t('location.body.title')}</p>
          </div>
          <div>
            <MapKakao/>
          </div>
          <div className={`flex flex-col mt-10 lg:flex-row lg:w-[700px] lg:justify-start`}>
            <p className="text-2xl mb-2 lg:mb-0 lg:text-3xl lg:w-[300px]">{t('location.body.info-title')}</p>
            <div className="">
              <p className="my-1" dangerouslySetInnerHTML={{__html:address}}></p>
              <p className="my-1" dangerouslySetInnerHTML={{__html:contact}}></p>
              <p className="my-1" dangerouslySetInnerHTML={{__html:email}}></p>
            </div>
          </div>
        </div>
      </div>
    </PageWrapper>
  );
}